import { Send } from "lucide-react";

export const ChatMessages = ({ msgs, fr, bottomRef }) => (
  <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-[#FAF7F2]" data-lenis-prevent data-testid="chat-messages">
    {msgs.length === 0 && <p className="text-sm text-stone-500 leading-relaxed">{fr ? "Bonjour ! Une question sur nos produits, la préparation, la livraison ? Je vous réponds — sans promesse miracle." : "Hello! A question about our products, preparation or shipping? Ask away — no miracle promises."}</p>}
    {msgs.map((m) => (
      <div key={m.id} className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed whitespace-pre-line ${m.role === "user" ? "ml-auto bg-stone-900 text-white" : "bg-white border border-stone-200 text-stone-800"}`} data-testid={`chat-msg-${m.role}`}>
        {m.content || <span className="inline-block w-8 text-stone-400 animate-pulse">…</span>}
      </div>
    ))}
    <div ref={bottomRef} />
  </div>
);

export const ChatInput = ({ input, setInput, onSend, busy, fr }) => (
  <>
    <form onSubmit={onSend} className="p-3 border-t border-stone-200 flex gap-2">
      <input data-testid="chat-input" value={input} onChange={(e) => setInput(e.target.value)} placeholder={fr ? "Votre question…" : "Your question…"} className="flex-1 rounded-full border border-stone-300 px-4 py-2.5 text-sm focus:outline-none focus:border-[#C85A32]" />
      <button data-testid="chat-send" disabled={busy || !input.trim()} className="w-10 h-10 rounded-full bg-stone-900 text-white flex items-center justify-center hover:bg-[#C85A32] disabled:opacity-50"><Send size={15} /></button>
    </form>
    <p className="px-4 pb-2 text-[9px] text-stone-400 text-center">{fr ? "Assistant IA — ne remplace pas un avis médical. Pas de données bancaires ici." : "AI assistant — not medical advice. No card data here."}</p>
  </>
);

// Reads a Server-Sent-Events stream and calls onDelta(text) for every chunk
export const readSseStream = async (res, onDelta, onError) => {
  const reader = res.body.getReader(); const dec = new TextDecoder(); let buf = "";
  while (true) {
    const { value, done } = await reader.read(); if (done) break;
    buf += dec.decode(value, { stream: true });
    const lines = buf.split("\n\n"); buf = lines.pop();
    for (const l of lines) {
      if (!l.startsWith("data: ")) continue;
      const d = l.slice(6); if (d === "[DONE]") continue;
      const j = JSON.parse(d);
      if (j.error) onError(); else if (j.delta) onDelta(j.delta);
    }
  }
};
